export const API_END_POINTS = {
  login: "user/login",
  getProfileDetails: "user/profile",
  editProfileDetails: "user/profile",
  changePassword: "user/change-password",
  register: "user/create",
  VERIFY_OTP: "user/verify-otp",
  FORGOT_PASSWORD: "user/forgot-password",
  RESET_PASSWORD: "user/set-password",
  home_banners: "user/home-banners",
  app_settings: "user/app-settings",
  search_category_list: "user/category-list",
  searchProducts: "user/productsList",
  productSuggestions: "user/productSuggestions",
  product: "user/product",
  newArrival: "user/newArrival",
  specificProducts: "user/specificProducts",
  relatedProducts: "user/similarProducts",
  productReview: "user/product-review",
  addToCart: "user/add-to-cart",
  updateCart: "user/update-cart",
  getCart: "user/get-cart",
  getCartCount: "user/get-cart-item-count",
  removeFromCart: "user/remove-cart-item",
  addToWishlist: "user/wishlist",
  getWishlist: "user/wishlist",
  removeFromWishlist: "user/wishlist",
  addAddress: "user/add-address",
  showAddress: "user/addressess",
  editAddress: "user/update-address",
  deleteAddress: "user/delete-address",
  placeOrder: "user/place-order",
  stripePayment: "user/stripe-charge",
  paypalPayment: "",
  kalranaPayment: "user/generate-klarna-order",
  order: "user/orders",
  couponValidate: "user/coupon-validate",
  productRivew: "user/post-product-review",
  FAQS: "user/faqs",
  ATTACHMENTS: "user/attachments",
  ASK_A_QUESTION: "user/ask-a-question",
  FOOTER_PAGES_CONTENT: "/user/page-by-id",
  support_form: "user/support-form",
  contact_us: "user/contact-form",
  faqs: "user/faq",
  testimonial: "user/testimonial",
};
